export var ReasonForDepersonalization;
(function (ReasonForDepersonalization) {
    ReasonForDepersonalization["Automatic"] = "Automatic";
    ReasonForDepersonalization["IncorrectOrder"] = "IncorrectOrder";
    ReasonForDepersonalization["DuplicateOrder"] = "DuplicateOrder";
    ReasonForDepersonalization["Canceled"] = "Canceled";
    ReasonForDepersonalization["WithdrawnOrder"] = "WithdrawnOrder";
})(ReasonForDepersonalization || (ReasonForDepersonalization = {}));
